// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-shadow[data-v-7685503a]{border:2px solid rgba(0,0,0,.35)}.make-black[data-v-7685503a]{color:#000}.save-button[data-v-7685503a]{background-color:#4abca5;color:#fff}", ""]);
// Exports
module.exports = exports;
